import { jsx } from "react/jsx-runtime";
import React__default from "react";
import classNames from "classnames";
import { AnalyticsId } from "./constants.js";
import titleStyles from "./components/Title/styles.module.scss";
const Title = React__default.forwardRef(function TitleForwardedRef(props, ref) {
  const { id, children, className, htmlMarkup = "h1", appearance = "title1", margin = 0, testId } = props;
  const titleClasses = classNames(
    titleStyles.title,
    {
      [titleStyles["title--feature"]]: appearance === "titleFeature",
      [titleStyles["title--title1"]]: appearance === "title1",
      [titleStyles["title--title2"]]: appearance === "title2",
      [titleStyles["title--title3"]]: appearance === "title3",
      [titleStyles["title--title4"]]: appearance === "title4",
      [titleStyles["title--title5"]]: appearance === "title5",
      [titleStyles["title--title6"]]: appearance === "title6"
    },
    className
  );
  const CustomTag = htmlMarkup;
  const inlineStyle = instanceOfTitleMargin(margin) ? { marginTop: `${margin.marginTop}rem`, marginBottom: `${margin.marginBottom}rem` } : { marginTop: `${margin}rem`, marginBottom: `${margin}rem` };
  return /* @__PURE__ */ jsx(CustomTag, { id, className: titleClasses, style: inlineStyle, ref, "data-testid": testId, "data-analyticsid": AnalyticsId.Title, children });
});
const instanceOfTitleMargin = (margin) => {
  return Object.prototype.hasOwnProperty.call(margin, "marginTop") && Object.prototype.hasOwnProperty.call(margin, "marginBottom");
};
export {
  Title as T,
  instanceOfTitleMargin as i
};
//# sourceMappingURL=Title.js.map
